import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { productSliceReducer } from "./productsListing";
import { emailSliceReducer } from "./sendMail";

import { persistStore, persistReducer } from "redux-persist";
import {
  favouritesRecipeSlice,
  homepageRecipeSlice,
  messageSlice,
  preferencesSlice,
} from "./recipes/recipeSlice";
import algoliaSlice from "./recipes/algoliaSlice";
import gigyaslice from "./gigya";
import sceneSlice from "./gigya/scene";
import logoutSlice from "./gigya/logout";
import ghostCardSlice from "./gigya/ghostCard";
import SceneCardInfoSlice from "./sceneCardInformation";
import verifyCardMessageSlice from "./gigya/verify-card";
import refineMiddleware from "./recipes/reduxMiddleware";

import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { paginationSlice } from "./common/pagination";
import {
  listStoreReducer,
  otherStoreInfoReducer,
  selectedStoreReducer,
  storeAemDataReducer,
} from "@/utils/redux/storeLocator/index";
import { guidanceAemReducer } from "@/utils/redux/guidance";
import { AemModalSlice, getAemDataSlice } from "./recipes/aemContentSlice";
import { getProductAemDataSlice } from "./productsListing/aemContentSlice";
import { addRecipeToListReducer } from "./recipes/addtolistSlice";
import { algoliaReducer } from "@/utils/redux/algolia/index";
import { getFaqDataSlice } from "./Faq/faqContentSlice";
import { getEntertainingDataSlice } from "./entertaining";
import { manageListReducer } from "./manageList";
import { shoppingListSliceReducer } from "./shoppingList";
import { getContactFormDataSlice } from "./contactForm";
import { AdsReducer } from "./ads";
import { getRostDataSlice } from "./roast/rostCalculator";
import { getRoastCalculatorLayoutSlice } from "./roast/roastAem/aemContentSlice";
import { favouriteProductSliceReducer } from "./favouriteProduct";
import { getProductDetailsDataSlice } from "./productDisclaimer";
import { cartProductSliceReducer } from "./cartProduct";
import aemStaticSearchData from "./aem/searchData";
import AemArticledataSlice from "./article/aemContent";
import { toastMessageSlice } from "./recipes/toastMessageSlice";
import { getGrillingGuideLayoutSlice } from "./grillingGuideLayuout";
import { getReadyForYouDataSlice } from "./readyForYou/readyForYou";
import { getReadyForYouLayoutSlice } from "./readyForYou/readyForYouAem/aemContentSlice";
import { FavoirateOffersReducer } from "./favOffers";
import { getScenePlusDataSlice } from "./shoppingListScenePlus";
import sceneContentReducer from "@/utils/redux/scene/sceneContentSlice";
import { featuredProductsSliceReducer } from "./featuredProducts";
import { offersReducer } from "./fetchOffers";
import { mealPlanMessageSlice, mealPlanReducer } from "./mealPlan/mealPlanSlice";
import { recipePersonalNoteSlice } from "./recipes/personalNoteSlice";
import { getShoppingListDataSlice } from "./ManagelListingSlice";
import { GeneralOffersReducer } from "./generalOffers";
import { dataLayerSlices, setDataLayerSlice } from "./dataLayerSlice";
import { FlyerDataReducer } from "./flyer";

type KeyValue = string | number | boolean | object | null;
const createNoopStorage = () => {
  return {
    getItem(_key: string | number) {
      return Promise.resolve(null);
    },
    setItem(_key: string, value: KeyValue) {
      return Promise.resolve(value);
    },
    removeItem(_key: string | number) {
      return Promise.resolve();
    },
  };
};

const persistConfig = {
  key: "root", // Key for storage
  storage:
    typeof window !== "undefined"
      ? createWebStorage("session")
      : createNoopStorage(), // Default: localStorage for web
  whitelist: [
    "manageListSlice",
    "shoppingListSlice",
    "cartProductSlice",
    "favouriteProductSlice",
    "productsSlice",
    "favoirateOffersSlice",
    "featuredProductsSlice",
    "offersSlice",
  ],
};

const rootReducer = combineReducers({
  productsSlice: productSliceReducer,
  featuredProductsSlice: featuredProductsSliceReducer,
  manageListSlice: manageListReducer,
  shoppingListSlice: shoppingListSliceReducer,
  favouritesRecipeSlice: favouritesRecipeSlice,
  paginationSlice: paginationSlice,
  algoliaDataSlice: algoliaSlice,
  gigyaslice: gigyaslice,
  sceneSlice: sceneSlice,
  logoutSlice: logoutSlice,
  ghostCardSlice: ghostCardSlice,
  SceneCardInfoSlice: SceneCardInfoSlice,
  verifyCardMessageSlice: verifyCardMessageSlice,
  messageSlice: messageSlice,
  AemModalSlice: AemModalSlice,
  listStore: listStoreReducer,
  selectedStore: selectedStoreReducer,
  otherStoreInfo: otherStoreInfoReducer,
  storeAemData: storeAemDataReducer,
  guidanceAemContent:guidanceAemReducer,
  preferencesSlice: preferencesSlice,
  getAemDataSlice: getAemDataSlice,
  AemArticledataSlice: AemArticledataSlice,
  getRoastCalculatorLayoutSlice: getRoastCalculatorLayoutSlice,
  EmailSlice: emailSliceReducer,
  getProductAemDataSlice: getProductAemDataSlice,
  RecipeToList: addRecipeToListReducer,
  algoliaSlice: algoliaReducer,
  getRostDataSlice: getRostDataSlice,
  faqSlice: getFaqDataSlice,
  shoppingListScenePLusSlice: getScenePlusDataSlice,
  entertainingDataSlice: getEntertainingDataSlice,
  contactFormSlice: getContactFormDataSlice,
  adsSclice: AdsReducer,
  favouriteProductSlice: favouriteProductSliceReducer,
  getProductDetailsDataSlice: getProductDetailsDataSlice,
  getShoppingListDataSlice:getShoppingListDataSlice,
  cartProductSlice: cartProductSliceReducer,
  aemStaticSearchData: aemStaticSearchData,
  toastMessageSlice: toastMessageSlice,
  getGrillingGuideLayoutSlice: getGrillingGuideLayoutSlice,
  getReadyForYouDataSlice: getReadyForYouDataSlice,
  getReadyForYouLayoutSlice: getReadyForYouLayoutSlice,
  favoirateOffersSlice: FavoirateOffersReducer,
  sceneContent: sceneContentReducer,
  offersSlice: offersReducer,
  homepageRecipeSlice: homepageRecipeSlice,
  mealPlanMessageSlice: mealPlanMessageSlice,
  MealPlan: mealPlanReducer,
  recipePersonalNoteSlice: recipePersonalNoteSlice,
  generalOffersSlice: GeneralOffersReducer,
  dataLayerSlices:dataLayerSlices,
  flyerDataSlice: FlyerDataReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for actions if necessary
    }).concat(refineMiddleware), // Add the refine middleware
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
